import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.grid-enter {
		opacity: 0;
	}

	&.grid-enter-active,
	&.grid-enter-done,
	&.grid-exit {
		opacity: 1;
	}

	&.grid-exit-active {
		opacity: 0;
	}
`;

const StyledLine = styled.div`
	background-color: rgba(255, 255, 255, 0.25);
`;

const StyledVerticalLine = styled(StyledLine)`
	width: 1px;
	height: 100%;
`;

const StyledHorizontalLine = styled(StyledLine)`
	width: 100%;
	height: 1px;
`;

const StyledLinesContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: grid;
	width: 100%;
	height: 100%;
`;

const StyledVerticalLinesContainer = styled(StyledLinesContainer)`
	grid-template-columns: 17% 1fr 1fr 17%;
`;

const StyledHorizontalLinesContainer = styled(StyledLinesContainer)`
	grid-template-rows: 17% 1fr 1fr 17%;
`;

export {
	StyledContainer,
	StyledVerticalLine,
	StyledHorizontalLine,
	StyledVerticalLinesContainer,
	StyledHorizontalLinesContainer,
};
